module.exports = __webpack_public_path__ + "static/media/205_SHOT_112.2561b342.webp";